<template>
  <span>
    <v-btn text @click="openDialog()"><v-icon>mdi-file-check</v-icon> Rapporto di Avvenuta Verifica</v-btn>
    <v-dialog v-model="dialog" max-width="50%">
      <v-card>
        <v-card-title>Stampa Rapporto di Avvenuta Verifica</v-card-title>
        <v-card-text>
          <v-autocomplete
            outlined
            dense
            label="Verificatore"
            :items="listaVerificatori"
            item-text="name"
            item-value="ad_user_id"
            v-model="ad_userverificatore_id"
          ></v-autocomplete>
          <v-autocomplete
            outlined
            dense
            label="Secondo Verificatore"
            :items="listaVerificatori"
            item-text="name"
            item-value="ad_user_id"
            v-model="ad_usersecondoverificatore_id"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialog = false">Chiudi</v-btn>
          <v-btn text color="primary" @click="print" :disabled="printDisabled"
            >Stampa</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
/*eslint-disable */
import mixin from "../mixin/MixingCommonComp";
export default {
  mixins: [mixin],
  props: {
    c_orderline_id: { type: Number, default: 0 },
  },
  data() {
    return {
      dialog: false,
      ad_userverificatore_id: 0,
      ad_usersecondoverificatore_id: 0,
      listaVerificatori: [],
    };
  },
  methods: {
    getVerificatori() {
      let parameters = {};
      parameters.data = {};
      parameters.idempiereRestPath = "vecos/getListaVerificatori";
      this.$store.dispatch("callIdempiereRest", parameters).then((response) => {
        this.listaVerificatori = response.data.listaVerificatori;
      });
    },
    openDialog() {
      this.ad_userverificatore_id = 0;
      this.ad_usersecondoverificatore_id = 0;
      this.dialog = true;
    },
    print() {
      this.dialog = false;
      console.log("downloadVerbale");
      this.$store.commit("setProgressMessage", "Download in corso");
      this.$store.commit("setProgressLoading", true);
      let parameters = {};
      parameters.idempiereRestPath = "print/addPrintJob";
      let data = {};
      data.parameters = JSON.stringify({
        RECORD_ID: this.c_orderline_id,
        ad_userverificatore_id: this.ad_userverificatore_id,
        ad_usersecondoverificatore_id: this.ad_usersecondoverificatore_id,
      });
      data.nomeStampa = "Attestazione Avvenuta Verifica";
      parameters.data = data;
      this.$store.dispatch("callIdempiereRest", parameters).then((response) => {
        console.log(response);
        if (response.data.hasOwnProperty("file")) {
          const linkSource =
            "data:application/pdf;base64," + response.data.file;
          const downloadLink = document.createElement("a");
          const fileName = "Attestazione Avvenuta Verifica.pdf";

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          this.$store.commit("setProgressMessage", null);
        } else {
          this.$store.commit("setProgressMessage", null);
          var errorMsg = "Download non riuscito";
          if (response.data.hasOwnProperty("message")) {
            errorMsg = errorMsg + "\n" + response.data.message;
          }
          this.$store.commit("setErrorMessage", errorMsg);
        }
      });
    },
  },
  mounted() {
    this.getVerificatori();
  },
  computed: {
    printDisabled() {
      if (this.c_orderline_id <= 0) return true;
      if (this.ad_userverificatore_id <= 0) return true;
      return false;
    },
  },
};
</script>

<style>
</style>